import React from "react";
import ResearchLayout, { useReveal } from "../ResearchLayout";

const APPROVALS = [
  {
    icon: "fa-stamp",
    title: "DRAP",
    full: "Drug Regulatory Authority of Pakistan",
    color: "linear-gradient(135deg, #076cec, #04b3bf)",
    body:
      "Maroof International Hospital Clinical Trial Unit is a DRAP-approved site for conducting clinical trials. Application guidelines and required forms are available on the DRAP website.",
    links: [
      { label: "Application Forms", url: "https://www.dra.gov.pk/publications/application-forms/#CT" },
      {
        label: "Clinical Trial Application Guidelines (PDF)",
        url: "https://www.dra.gov.pk/wp-content/uploads/2022/05/Guidelines-on-Clinical-Trial-Applications-For-Applicants.pdf",
      },
    ],
  },
  {
    icon: "fa-scale-balanced",
    title: "National Bioethics Committee",
    full: "Ministry of National Health Services, Pakistan",
    color: "linear-gradient(135deg, #047857, #10b981)",
    body:
      "The National Bioethics Committee is a notified body on bioethics working under the Ministry of National Health Services, Regulation and Coordination. All applications for authorization of clinical trials must seek prior approval from the NBC under Rules 9 of the Bio-Study Rules, 2017.",
    links: [
      {
        label: "Ethical Clearance Form (NBC Pakistan)",
        url: "http://nbcpakistan.org.pk/assets/ethical-clearance-of-research-project-through-nbc-pakistan.pdf",
      },
    ],
  },
  {
    icon: "fa-shield-halved",
    title: "Institutional Review Board",
    full: "U.S. Office for Human Research Protections",
    color: "linear-gradient(135deg, #7c3aed, #a855f7)",
    body:
      "Maroof's IRB is registered in the Office of Human Research Protection Database, United States Department for Health & Human Services.",
    badges: [
      { label: "IORG Number", value: "IORG0011525" },
      { label: "FWA Number", value: "FWA00032840" },
    ],
    links: [
      { label: "Search IRB Status (OHRP)", url: "https://ohrp.cit.nih.gov/search/search.aspx?styp=bsc" },
    ],
  },
];

export default function Regulatory() {
  useReveal();
  return (
    <ResearchLayout>
      <section
        style={{
          padding: "100px 0 60px",
          background: "linear-gradient(135deg, #0d3b6e 0%, #076cec 100%)",
          color: "#fff",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div className="rs-blob" style={{ width: 400, height: 400, background: "#7c3aed", top: "-150px", right: "-100px" }} />
        <div className="rs-container rs-text-center" style={{ position: "relative", zIndex: 2 }}>
          <span className="rs-section-eyebrow" style={{ background: "rgba(255,255,255,0.15)", color: "#fff", backdropFilter: "blur(10px)" }}>
            Compliance & Ethics
          </span>
          <h1 style={{ fontSize: "clamp(2rem, 5vw, 3.4rem)", fontWeight: 800, margin: "12px 0 16px" }}>
            Regulatory Approvals
          </h1>
          <p style={{ fontSize: "1.05rem", maxWidth: 720, margin: "0 auto", opacity: 0.85, lineHeight: 1.7 }}>
            Our clinical research framework operates under the highest standards of regulatory oversight,
            both nationally and internationally.
          </p>
        </div>
      </section>

      <section className="rs-section" style={{ paddingTop: 60 }}>
        <div className="rs-container">
          <div style={{ display: "grid", gap: 26 }}>
            {APPROVALS.map((a, i) => (
              <div
                key={a.title}
                className={`rs-reveal delay-${i + 1}`}
                style={{
                  background: "#fff",
                  borderRadius: 22,
                  padding: 0,
                  overflow: "hidden",
                  border: "1px solid rgba(7, 108, 236,0.08)",
                  display: "grid",
                  gridTemplateColumns: "200px 1fr",
                  transition: "transform 0.3s, box-shadow 0.3s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-6px)";
                  e.currentTarget.style.boxShadow = "0 20px 50px rgba(7, 108, 236,0.12)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div
                  style={{
                    background: a.color,
                    color: "#fff",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 24,
                    textAlign: "center",
                  }}
                  className="rs-approval-side"
                >
                  <div
                    style={{
                      width: 72,
                      height: 72,
                      borderRadius: "50%",
                      background: "rgba(255,255,255,0.2)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "2rem",
                      marginBottom: 14,
                      animation: "rsFloat 4s ease-in-out infinite",
                    }}
                  >
                    <i className={`fa-regular ${a.icon}`}></i>
                  </div>
                  <div style={{ fontWeight: 800, fontSize: "1.1rem", marginBottom: 4 }}>{a.title}</div>
                  <div style={{ fontSize: "0.72rem", opacity: 0.85, lineHeight: 1.4 }}>{a.full}</div>
                </div>

                <div style={{ padding: "30px 36px" }}>
                  <p style={{ margin: "0 0 18px", fontSize: "0.96rem", lineHeight: 1.75, color: "#374151" }}>
                    {a.body}
                  </p>

                  {a.badges && (
                    <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 18 }}>
                      {a.badges.map((b) => (
                        <div
                          key={b.label}
                          style={{
                            padding: "10px 18px",
                            borderRadius: 10,
                            background: "linear-gradient(135deg, #f0f7ff, #e6fffa)",
                            border: "1px solid rgba(7, 108, 236,0.1)",
                          }}
                        >
                          <div style={{ fontSize: "0.7rem", color: "#6b7280", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em" }}>
                            {b.label}
                          </div>
                          <div style={{ fontSize: "0.95rem", fontWeight: 800, color: "var(--rs-primary)", fontFamily: "monospace" }}>
                            {b.value}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                    {a.links.map((l) => (
                      <a
                        key={l.url}
                        href={l.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "var(--rs-primary)",
                          fontWeight: 600,
                          textDecoration: "none",
                          fontSize: "0.9rem",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 8,
                          transition: "all 0.2s",
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.color = "var(--rs-secondary)")}
                        onMouseLeave={(e) => (e.currentTarget.style.color = "var(--rs-primary)")}
                      >
                        <i className="fa-regular fa-arrow-up-right-from-square"></i>
                        {l.label}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <style>{`
            @media (max-width: 700px) {
              .rs-approval-side { padding: 30px !important; }
              .rs-section .rs-container > div > div { grid-template-columns: 1fr !important; }
            }
          `}</style>
        </div>
      </section>
    </ResearchLayout>
  );
}
